import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'

import UserActions from '../Redux/UserRedux'

import CreateAdmin from '../Containers/ManageAdmin/CreateAdmin'
import UpdateAdmin from '../Containers/ManageAdmin/UpdateAdmin'
import DeleteAdmin from '../Containers/ManageAdmin/DeleteAdmin'

class ManageAdminPage extends React.Component {
  constructor (props) {
    super(props)
    this.only_admins = true
    this.state = {
      showModal: null,
      detail: {},
      filter: {
        page: 1
      }
    }
  }

  componentDidMount = () => {
    this._fetchUser()
  }

  _fetchUser = (filter = { page: this.state.filter.page }) => {
    const params = {
      ...filter,
      only_admins: this.only_admins
    }

    this.props.getUser(params)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _select = (data, action) => {
    this.setState({ detail: data })
    this._toggleModal(action)
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._fetchUser({ page })
  }

  render () {
    const { user, auth } = this.props

    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Manage Admin
              {(user.fetching || user.processing) &&
                <div className='badge badge-info ml-2'>{user.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {(auth.user && auth.user.role === 'admin') && <button className='btn btn-primary ml-auto' onClick={() => this._toggleModal('create')}>Create Admin</button>}
          </div>
        </header>
        <section className='section'>
          <div className='card'>

            {!(user.fetching || user.processing) && user.err &&
              <div className='alert alert-danger'>{user.err}</div>
            }

            <div className='card-block'>
              <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                <thead>
                  <tr>
                    <th><strong>#</strong></th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th className='text-center'>Status</th>
                    <th className='text-center'>Update</th>
                    <th className='text-center'>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !user.data || (!user.data.data && !user.data.data.length)
                      ? <tr>
                        <td colSpan='11' className='text-center'>- No Data -</td>
                      </tr>
                      : user.data.data.map((item, i) => {
                        let name = '-'
                        if (item.first_name || item.last_name) {
                          name = item.first_name + ' ' + item.last_name
                        }
                        return (
                          <tr key={i} className={`admin-tr ${(auth.user && auth.user.id === item.id) ? 'table-success' : ''}`}>
                            <td>{ ((user.data.page - 1) * 10) + (i + 1) }</td>
                            <td>{ name }</td>
                            <td>{ item.email || '-' }</td>
                            <td>{ item.role || '-' }</td>
                            <td className='text-center'>
                              <label className={`badge badge-${item.active ? 'success' : 'danger'}`}>
                                {item.active ? 'Active' : 'Disabled'}
                              </label>
                            </td>
                            <td className='text-center'>
                              <button className='btn btn-primary' onClick={() => this._select(item, 'update')}>
                                <i className='fa fa-edit' />
                              </button>
                            </td>
                            <td className='text-center'>
                              {item.role !== 'admin'
                                ? <button className='btn btn-danger' onClick={() => this._select(item, 'delete')}>
                                  <i className='fa fa-trash' />
                                </button>
                                : '-----'
                              }
                            </td>
                          </tr>
                        )
                      })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* CREATE ADMIN */}
        <Modal open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateAdmin closeModal={() => this._toggleModal()} />
        </Modal>

        {/* UPDATE ADMIN */}
        <Modal open={this.state.showModal === 'update'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateAdmin detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* UPDATE ADMIN */}
        <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
          <DeleteAdmin detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <section className='text-center'>
          {(user.data && user.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={user.data.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={user.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  user: state.user,
  auth: state.auth
})

const dispatchToProps = (dispatch) => ({
  getUser: (filter) => dispatch(UserActions.userRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(ManageAdminPage)



// WEBPACK FOOTER //
// ./src/Pages/ManageAdminPage.js